"use client";

import { FormEvent, useState } from "react";

export default function EmailJSForm({dict}: {dict: any}) {
	const [uName, setUName] = useState("");
	const [uEmail, setUEmail] = useState("");
	const [uSubject, setUSubject] = useState("");
	const [uMessage, setUMessage] = useState("");
	const [infoBox, setInfoBox] = useState("");
	const [status, setStatus] = useState("");

	const handleSubmit = async (e: FormEvent) => {
		e.preventDefault();

		var data = {
			service_id: "service_6890w8h",
			template_id: "template_118lsyo",
			user_id: "XY-H3hFpKMz_jT1ds",
			template_params: {
				sender_name: uName,
				sender_email: uEmail,
				subject: uSubject,
				message: uMessage,
			},
		};

		const res = await fetch("https://api.emailjs.com/api/v1.0/email/send", {
			method: "POST",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
		})
			.then((res) => {
				if (res.status === 200) {
					setInfoBox(dict.contact.form.success);
					setStatus("success");
					setUName("");
					setUEmail("");
					setUSubject("");
					setUMessage("");
				} else {
					setInfoBox(dict.contact.form.error + res.status);
					setStatus("error");
				}
			})
			.catch((err) => {
				setInfoBox(dict.contact.form.error + err);
				setStatus("error");
			});
	};

	return (
		<form className="contactForm" onSubmit={handleSubmit}>
			<h2>{dict.contact.formTitle}</h2>
			<div className="field">
				<input
					id="name"
					type="text"
					name="name"
					value={uName}
					required
					onChange={(e) => setUName(e.target.value)}
				/>
				<label htmlFor="name" title={dict.contact.form.name} data-title={dict.contact.form.name}></label>
			</div>
			<div className="field">
				<input
					id="email"
					type="text"
					name="email"
					value={uEmail}
					required
					onChange={(e) => setUEmail(e.target.value)}
				/>
				<label htmlFor="email" title={dict.contact.form.email} data-title={dict.contact.form.email}></label>
			</div>
			<div className="field">
				<input
					id="subject"
					type="text"
					name="subject"
					value={uSubject}
					required
					onChange={(e) => setUSubject(e.target.value)}
				/>
				<label htmlFor="subject" title={dict.contact.form.subject} data-title={dict.contact.form.subject}></label>
			</div>
			<div className="field">
				<textarea
					name="message"
					id="message"
					value={uMessage}
					required
					onChange={(e) => setUMessage(e.target.value)}
				/>
				<label htmlFor="message" title={dict.contact.form.message} data-title={dict.contact.form.message}></label>
			</div>
			<p className={`infoBox ${status}`}>{infoBox}</p>
			<input className="submitBtn" type="submit" value={dict.contact.form.submit} />
			<p className="alternativeSolution">{dict.contact.alternative} <span className="attention">sales@htrefrakter.com.tr</span> {dict.contact.or} <span className="attention">+90 (532) 614 20 87</span>{dict.contact.turkishAddition}.</p>
		</form>
	);
}
